<template>
  <div class="orderHistory">
    <div class="top-block">
      <header>
        <h4>{{$t('orderHistory')}}</h4>
        <form action>
          <div class="search-box" id="contn">
            <input type="text" placeholder="Search..." />
            <span @click="closeSearch">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                <path
                  fill="#CDCDCD"
                  fill-rule="nonzero"
                  d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                  opacity=".675"
                />
              </svg>
            </span>
          </div>
          <span class="search-icon" @click="openSearch">
            <img src="../assets/images/icons/search.png" alt style="visibility:hidden" />
          </span>
        </form>
      </header>
      <ul class="orders-tab">
        <li class="orders-tab" :class="{'active' : !isActive}">
          <input
            type="radio"
            id="test1"
            name="radio-group"
            value="pre_order"
            v-model="orderStatus"
            @change="changeStatus('pre_order')"
          />
          <label for="test1">{{$t('yourPendingOrders')}}</label>
        </li>
        <li class="orders-tab" :class="{'active' : isActive}">
          <input
            type="radio"
            id="test2"
            name="radio-group"
            value="post_order"
            v-model="orderStatus"
            @change="changeStatus('post_order')"
          />
          <label for="test2">{{$t('yourOrders')}}</label>
        </li>
      </ul>
    </div>

    <InitiatedOrder v-if="orderStatus === 'pre_order' " />
    <MyOrders  v-if="orderStatus === 'post_order' "   />
  </div>
</template>

<script>
import "../assets/css/order-history.scss";
import "../assets/css/scratch-card.scss";
import InitiatedOrder from "../components/OrderHistorySection/InitiatedOrder";
import MyOrders from '../components/OrderHistorySection/MyOrders';
export default {
  name: "OrderHistory",
  components: {
    InitiatedOrder,
      MyOrders
  },
  data() {
    return {
      orderStatus: "pre_order",
      isActive: false
    };
  },
  methods: {
    openSearch() {
      var element = document.getElementById("contn");
      element.classList.add("show");
    },
    closeSearch() {
      var element = document.getElementById("contn");
      element.classList.remove("show");
    },
    changeStatus(order_status) {
      this.$cookie.set("orderStatus", order_status);
      if (this.$cookie.get("orderStatus") == "pre_order") {
        this.isActive = !this.isActive;
      } else {
        this.isActive = !this.isActive;
      }
    }
  },
    mounted() {
    this.orderStatus = this.$cookie.get("orderStatus");
    if (this.$cookie.get("orderStatus") == "post_order") {
      this.isActive = !this.isActive;
    } else {
      this.isActive = !this.isActive;
    }
    if (this.orderStatus == null) {
      this.orderStatus = "pre_order";
    }
    if (this.orderStatus == "pre_order") {
      this.isActive = !this.isActive;
    }
  },
};
</script>